import { PhoneOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import styled from 'styled-components'
import { translate } from '../../languages'
import { ApiMethodEnum, UserTypeEnum } from '../../models'
import { RootState } from '../../stores'
import { setShowManageModal } from '../../stores/actions'

const LinkCall = styled.a`
  text-decoration: none;
`

type TableActionColumnButtonComponentProps = {
  onViewButtonClick?: () => void
  onDeleteButtonClick?: () => void
  phone?: string
}

export const TableActionColumnButtonComponent: React.FC<TableActionColumnButtonComponentProps> =
  ({ onViewButtonClick, onDeleteButtonClick, phone }) => {
    const location = useLocation()
    const dispatch = useDispatch()
    const { language } = useSelector((state: RootState) => state.language)
    const { profile } = useSelector((state: RootState) => state.auth)
    const { apis } = useSelector((state: RootState) => state.api)

    return (
      <>
        {onViewButtonClick && (
          <Button
            style={{
              margin: '2.5px',
            }}
            type="primary"
            onClick={() => {
              onViewButtonClick()
              dispatch(setShowManageModal(true))
            }}
            size="small"
          >
            {translate('common.view', language)}
          </Button>
        )}
        {(profile?.userType.type === UserTypeEnum.ADMIN ||
          apis.filter(
            (item) =>
              item.method === ApiMethodEnum.DELETE &&
              item.path === location.pathname
          ).length > 0) &&
          onDeleteButtonClick && (
            <Button
              style={{
                margin: '2.5px',
              }}
              type="primary"
              danger
              size="small"
              onClick={() => {
                onDeleteButtonClick()
                dispatch(setShowManageModal(true))
              }}
            >
              {translate('common.delete', language)}
            </Button>
          )}
        {phone && (
          <LinkCall href={`tel:${phone}`}>
            <Button
              style={{
                margin: '2.5px',
              }}
              type="default"
              size="small"
              icon={<PhoneOutlined />}
            >
              {translate('common.call', language)}
            </Button>
          </LinkCall>
        )}
      </>
    )
  }
